import { useParams, Link } from "react-router-dom";
import { ArrowLeft } from "lucide-react";
import { BLOG } from "@/data/content";
import { Overline, AddToCartButton, Btn } from "@/components/common/ui";

export default function BlogPost() {
  const { slug } = useParams();
  const post = BLOG.find((b) => b.slug === slug) || BLOG[0];
  const more = BLOG.filter((b) => b.slug !== post.slug).slice(0, 2);

  return (
    <div data-testid="blog-post-page" className="bg-[#FFFCFA]">
      <div className="relative h-[42vh] min-h-[20rem] overflow-hidden">
        <img src={post.cover} alt={post.title} className="absolute inset-0 h-full w-full object-cover" />
        <div className="absolute inset-0 bg-[#232222]/45" />
        <div className="relative mx-auto flex h-full max-w-3xl flex-col justify-end px-6 pb-12 text-[#FFFCFA]">
          <Overline>{post.tags.join(" · ")} · {post.read}</Overline>
          <h1 className="mt-3 font-display text-4xl font-light leading-tight sm:text-5xl">{post.title}</h1>
          <p className="mt-3 text-sm text-[#F3E0D6]">{post.author} · {post.date}</p>
        </div>
      </div>

      <article className="mx-auto max-w-3xl px-6 py-16">
        <Link to="/blog" className="mb-10 inline-flex items-center gap-2 text-xs uppercase tracking-[0.18em] text-[#8A7F86] hover:text-[#2C2B2C]"><ArrowLeft className="h-4 w-4" /> All Articles</Link>
        {post.body.map((b, i) => (
          <div key={i} className="mb-9">
            <h2 className="font-display text-2xl font-medium text-[#2C2B2C] sm:text-3xl">{b.h}</h2>
            <p className="mt-4 text-lg font-light leading-relaxed text-[#8A7F86]">{b.p}</p>
          </div>
        ))}

        <div className="mt-12 rounded-[2rem] border border-[#F2E8E6] bg-white p-8 text-center">
          <h3 className="font-display text-3xl font-light text-[#2C2B2C]">Ready to glow?</h3>
          <p className="mt-3 text-[#8A7F86]">Experience clinically-backed LED therapy in 10 minutes a day.</p>
          <div className="mt-6 flex justify-center"><AddToCartButton sku="single" label="Shop the Mask" testid="blogpost-add" /></div>
        </div>
      </article>

      <section className="border-t border-[#F2E8E6] py-16">
        <div className="mx-auto max-w-[1400px] px-6 md:px-12">
          <h2 className="mb-8 font-display text-3xl font-light text-[#2C2B2C]">Before you go…</h2>
          <div className="grid gap-7 md:grid-cols-2">
            {more.map((m) => (
              <Link key={m.slug} to={`/blog/${m.slug}`} className="group flex gap-5 rounded-[2rem] border border-[#F2E8E6] bg-[#FFFCFA] p-5">
                <img src={m.cover} alt={m.title} className="h-28 w-28 flex-none object-cover" />
                <div>
                  <span className="text-xs uppercase tracking-wider text-[#FBC4A8]">{m.read}</span>
                  <h3 className="mt-2 font-display text-xl leading-tight text-[#2C2B2C] group-hover:text-[#FBC4A8]">{m.title}</h3>
                </div>
              </Link>
            ))}
          </div>
        </div>
      </section>
    </div>
  );
}
